import { render } from "./BookingHeader.vue?vue&type=template&id=18476276&scoped=true"
import script from "./BookingHeader.vue?vue&type=script&lang=js"
export * from "./BookingHeader.vue?vue&type=script&lang=js"

import "./BookingHeader.vue?vue&type=style&index=0&id=18476276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18476276"]])

export default __exports__